import { render, staticRenderFns } from "./TaxFormW8.vue?vue&type=template&id=166cddb3&scoped=true"
import script from "./TaxFormW8.vue?vue&type=script&lang=ts"
export * from "./TaxFormW8.vue?vue&type=script&lang=ts"
import style0 from "./TaxFormW8.vue?vue&type=style&index=0&id=166cddb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166cddb3",
  null
  
)

export default component.exports